const SYNC_FLOW_MEDIA_STEPS = {
  PRODUCT_MEDIA: 'productMedia',
  VARIANT_MEDIA: 'variantMedia',
  ALT_CONFLICTS: 'altConflicts',
};

export default SYNC_FLOW_MEDIA_STEPS;
